export default __webpack_public_path__ + "927fa151678bde5c0762f207d1513605.svg";